import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { getUserData } from 'src/utils/getUserInfo';

interface UserContextType {
    role: string | null;
    setRole: (role: string | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserProviderProps {
    children: ReactNode;
}

export const UserProvider = ({ children }: UserProviderProps) => {
    const [role, setRole] = useState<string | null>(null);

    useEffect(() => {
        getUserData().then((user) => {
            if (user?.groupName) setRole(user.groupName);
        });
    }, []);

    return (
        <UserContext.Provider value={{ role,setRole }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUserRole = (): UserContextType => {
    const context:any = useContext(UserContext);
    if (!context) {
        //console.log("useUserRole must be used within a UserProvider");
    }
    return context;
};
